import React from "react";
import { Helmet } from "react-helmet";

import Additionalimg1 from "../../new_Images/OtherComponents/22.png";
import Additionalimg2 from "../../new_Images/OtherComponents/Software Tool Development.png";
import Additionalimg4 from "../images/softtt.png";
import Additionalimg5 from "../../new_Images/OtherComponents/Bug Found.png";

import Addimg1 from "../images/Addimg1N.jpg";
import Addimg2 from "../images/azure.png";
import Addimg3 from "../images/Addimg3.png";
import Addimg4 from "../images/Addpostman.png";
import Addimg5 from "../images/addjira.jpg";
import Addimg6 from "../images/Addimg6.png";

import "../../App.css";

function AdditionalServices() {
  return (
    <>
      <Helmet>
        <title>Additional Services | CLOTA Technology</title>
        <meta
          name="description"
          content="Explore our additional services including software tool development, testing, and support to optimize your business productivity."
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Additional Services | CLOTA Technology"
        />
        <meta
          property="og:description"
          content="We provide a diverse range of software support services tailored to your business challenges."
        />
                 <meta name="robots" content="index, follow" />
  <meta name="author" content="Clota Technology" />
  <link rel="canonical" href="https://www.clotatech.com/AdditionalServices" />
      </Helmet>

      {/* <div>
        <img src={Additionalimg1} className="w-full homebanner" alt="Banner" />
      </div> */}
      <div className="banner-container">
        <img src={Additionalimg1} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">Additional Services</h1>
            <p>
              Connect with professionals who utilize our additional
              <br />
              software services to meet diverse business needs.
            </p>
          </div>
        </div>
      </div>

      {/* Heading paragraph */}
      {/* <div className="mt-5 px-5 py-2">
        <h2
          className="text-center Text-Gradient"
          style={{ fontFamily: "rockwell" }}
        >
          <hr />
          <b>
            Clota Technology provide a diverse range of additional services to meet specific
            needs and challenges.
          </b>
          <hr />
        </h2>
      </div> */}

                
                <div
        className="px-5 py-2 text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}
      >
        <h2 >
          <hr></hr>

          <b>Clota Technology provide a diverse range of additional services to meet specific
            needs and challenges.</b>
            <hr></hr>

        </h2>
      </div>

      {/* Software tool development */}
      <div className="grid align-items-center mt-5 px-5 py-2">
        <div className="col-12 md:col-6">
          <h4 className="Text-Gradient" style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}>
            <b>
              <i>Software Tool Development</i>
            </b>
          </h4>
          <i>
            <p>
              Software tools optimize business processes, document development,
              and improve project productivity. Our software tool development
              approach focuses on meeting company expectations, tool
              effectiveness, integration, choosing the right environment, and
              minimizing the learning curve.
            </p>
          </i>
        </div>

        <div className="col-12 md:col-6 flex justify-content-center">
          <img
            src={Additionalimg2}
            alt="Software Tool"
            className="img"
            style={{
              width: "420px",
              height: "300px",
              filter: "grayscale(100%)",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.filter = "grayscale(0%)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.filter = "grayscale(100%)")
            }
          />
        </div>
      </div>

      {/* Tools Heading */}

                      <div
        className="px-5 py-2 text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}
      >
        <h2 >
          <hr></hr>

          <b>Using Best Software Development Tools</b>
            <hr></hr>

        </h2>
      </div>


      {/* Tools Images Grid */}
      <div className="grid mt-5 px-5 py-2">
        {[Addimg1, Addimg2, Addimg3, Addimg4, Addimg5, Addimg6].map(
          (img, idx) => (
            <div key={idx} className="col-12 sm:col-6 md:col-4 mb-3">
              <div
                className="border-round shadow-2"
                style={{ height: "150px", overflow: "hidden" }}
              >
                <img
                  src={img}
                  alt={`tool-${idx}`}
                  className="w-full h-full"
                  style={
                    idx === 2
                      ? {
                          width: "80%",
                          height: "80%",
                          marginLeft: "10%",
                          marginTop: "5%",
                        }
                      : {}
                  }
                />
              </div>
            </div>
          )
        )}
      </div>

      {/* Software Support and Testing */}
      <div className="grid mt-5 px-5 py-2 align-items-center">
        <div className="col-12 md:col-6 flex justify-content-center">
          <img
            src={Additionalimg4}
            alt="Support"
            style={{ width: "350px", height: "270px" }}
          />
        </div>

        <div className="col-12 md:col-6">
          <h4 className="Text-Gradient" style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}>
            <b>
              <i>Software Support and Testing</i>
            </b>
          </h4>
          <i>
            <p>
              Software, being developed by humans, can't be expected to be
              defect-free, especially with millions of lines of code. Defects
              arise from unclear requirements, programming errors, complex
              system design, poor documentation, and challenges in managing
              software design changes.
            </p>
            <p>
              Clota Technology overcome these problems by multiple testing and using testing
              tools.
            </p>
          </i>
        </div>
      </div>

      {/* Bug Image */}
      <div className="flex justify-content-center">
        <img
          src={Additionalimg5}
          alt="Bug Found"
          className="img"
          style={{ maxWidth: "50%", height: "auto" }}
        />
      </div>

      {/* Our Software Support */}
      <div className="mt-5 px-5 py-2">
        <div className="grid">
          <div className="col-12">
            <h4 className="Text-Gradient" style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}>
              <b>
                <i>Our Software Support</i>
              </b>
            </h4>
            <p className="mbr-text mbr-fonts-style display-7">
              <i>
                We provide crucial after-sales support, ensuring efficient issue
                resolution. Our software support promptly handles inquiries,
                updates, and bug fixes for optimal usage. With our Live Agent,
                you get quick problem resolution and software updates.
              </i>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdditionalServices;
